import { put, select } from "redux-saga/effects";
import { actions as getMyProductsActions } from "@/reducers/get-my-products-reducer";
import { parsePrice } from "@/utils/common/price";
import { INCLUDED_R2R_DISCOUNTS_BY_CFI, PROFILES, R2R_V2_306_DISCOUNTS_BY_CFI, USUARIO_NO_LOGADO, USUARIO_PRIMER_R2R_INCLUIDO, USUARIO_SEGUNDO_R2R_INCLUIDO } from "@/constants/get-my-products";
import { getR2RTypeByOfferCategory } from "@/utils/normalizers/devices-list";
// import mockGetMyProducts from '@/constants/mock-json/get-my-products/mock_get-my-products.json';

const mainStore = (state) => state.main;

export function* getMyProducts() {
  function verifyRedirect(statusCode) {
    if (statusCode === 401) {
      let urlDestino = encodeURIComponent(window.location.href);
      let nuevaURL = `https://www.movistar.es/particulares/cms/auth/expired/?origin=web&reason=TCOL_unauthorized&redirect=${urlDestino}`
      window.location.href = nuevaURL;
    }
  }
  try {
    //const secureStorage = new SecureStorage();
    const main = yield select(mainStore);
    const { customer, userCompatibilities } = main;
    const userPq = {
      ppt: null, cfi: null, f: false, halmsm: false, foc: false,
      ...main.userPq,
      clt: main.userPq?.clt || USUARIO_NO_LOGADO,
    };
    //const persistedInfo = secureStorage.getItem("ts");
    //const userPq = persistedInfo && persistedInfo.userPq;
    //Get queryParam profile

    if (userPq) {
      //const customer = userPq.customer;
      const r2rCompatibilities = userCompatibilities?.r2r;
      let renewalRedeemed = false;

      if (customer) {
        const redeemedCampaigns = customer?.campaigns?.redeemed;
        if (Array.isArray(redeemedCampaigns)) {
          renewalRedeemed = redeemedCampaigns.some((campaign) => campaign.campaignId === "r2r_renovacion_principal");
        }
        if (Array.isArray(customer.profiles)) {
          userPq.profiles = customer.profiles.map(profile => profile.id);
          if (userPq.clt === USUARIO_SEGUNDO_R2R_INCLUIDO) {
            userPq.isUserNewModelR2R = true;
            const user306Profile = customer.profiles.some(profile => profile.id === PROFILES.R2R_V2);
            if (user306Profile && userPq.cfi && !userPq.ecfi) {
              userPq.userDiscountNewModelR2R = R2R_V2_306_DISCOUNTS_BY_CFI[userPq.cfi];
            } else if (!user306Profile) {
              userPq.userDiscountNewModelR2R = INCLUDED_R2R_DISCOUNTS_BY_CFI[userPq.cfi];
            }
          }
        }
        if (userPq.clt === USUARIO_PRIMER_R2R_INCLUIDO) {
          userPq.isUserNewModelR2R = true;
          if (userPq.cfi && !userPq.ecfi) {
            userPq.userDiscountNewModelR2R = INCLUDED_R2R_DISCOUNTS_BY_CFI[userPq.cfi];
          }
        }
      }
      if (Array.isArray(r2rCompatibilities?.hiredR2R)) {
        //Máximo 5 r2r por cliente, 4 para packs
        userPq.maxR2RReached = r2rCompatibilities?.hiredR2R?.length > 4;
        userPq.maxPackR2RReached = r2rCompatibilities?.hiredR2R?.length > 3;
        let includedR2RInfo = r2rCompatibilities.hiredR2R.find((item) => item.productOfferingType === 'TERMINAL_R2R_INCLUIDO' && item?.leasing?.isCancellable);
        //Si no encuentro ninguno cancelable, busco si hay algun incluido
        if (!includedR2RInfo) {
          includedR2RInfo = r2rCompatibilities.hiredR2R.find((item) => item.productOfferingType === 'TERMINAL_R2R_INCLUIDO');
        }
        if (includedR2RInfo) {
          userPq.includedR2RInfo = {
            isCancellable: includedR2RInfo?.leasing?.isCancellable && !includedR2RInfo.hasMobileInsurance && !renewalRedeemed,
            cancellationFee: parsePrice(includedR2RInfo?.leasing?.cancellationFee),
            productName: includedR2RInfo?.productName,
            endDate: includedR2RInfo?.leasing?.endDate ?
              new Date(includedR2RInfo?.leasing?.endDate).toLocaleDateString() :
              null
          }
        }
      }
      const { clt } = userPq;
      // Fuerza cliente en base al offerCategory
      if (clt === USUARIO_NO_LOGADO || !clt) {
        const searchParams = new URLSearchParams(window.location.search);
        const offerCategory = searchParams.get('offerCategory');
        if (offerCategory) {
          const {
            fusionCategoryId,
            clientType
          } = getR2RTypeByOfferCategory(offerCategory);
          if (clientType !== null && fusionCategoryId !== null) {
            userPq.cfi = fusionCategoryId;
            userPq.clt = clientType;
            userPq.foc = true;
          }
        }
        //Fuerza profiles (colectivos)
        const profileQueryParam = searchParams.getAll("userProfileId");
        const sessionStoredProfile = sessionStorage.getItem("profiles")?.split(",");
        const profiles = profileQueryParam.length > 0 ? profileQueryParam : sessionStoredProfile;
        if (Array.isArray(profiles) && profiles.length > 0) {
          sessionStorage.setItem("profiles", profiles);
          userPq.profiles = profiles;
          const isUserNewModelR2R = profiles.includes(PROFILES.R2R_V2);
          if (isUserNewModelR2R) {
            userPq.isUserNewModelR2R = isUserNewModelR2R;
            userPq.userDiscountNewModelR2R = R2R_V2_306_DISCOUNTS_BY_CFI[userPq.cfi];
          }
        }
        if (userPq.clt === USUARIO_PRIMER_R2R_INCLUIDO && !userPq.isUserNewModelR2R) {
          userPq.isUserNewModelR2R = true;
          if (userPq.cfi && !userPq.ecfi) {
            userPq.userDiscountNewModelR2R = INCLUDED_R2R_DISCOUNTS_BY_CFI[userPq.cfi];
          }
        }
      }
      yield put(getMyProductsActions.setKindClient(userPq));
    }
  } catch (error) {
    if (error) {
      const { statusCode } = error;
      if (statusCode) {
        verifyRedirect(statusCode)
      }
    }
    yield put(getMyProductsActions.getMyProductsFailure(error));
    console.error("getMyProducts Error", error);
  }
}
